module.exports = __webpack_public_path__ + "media/images/mail-strip-f6d23684993469305e283d1444baf1da.png";